import { Paper } from '@material-ui/core';
import { useStyles } from '../../../styles';
import { ActionCardTitleRow } from './RecommendedActions/ActionCardTitleRow';
import { ActionCardFooter } from './RecommendedActions/ActionCardFooter';

interface ModalActionInfoProps {
  title: string;
  itemsCount: number;
  badgeLabel: string;
  description: string;
  priority?: 'High' | 'Medium' | 'Low';
}

export function ModalActionInfo({
  title,
  itemsCount,
  badgeLabel,
  description,
  priority,
}: ModalActionInfoProps) {
  const classes = useStyles();
  const actionTaken = description.replace('Action to be taken: ', '');

  return (
    <div className="py-4">
      <Paper variant="outlined" className={classes.indexAnalysisSummaryPaper}>
        <div className="flex flex-col gap-2">
          <ActionCardTitleRow
            title={title}
            itemsCount={itemsCount}
            badgeLabel={badgeLabel}
            priority={priority}
          />
          <ActionCardFooter
            hasWorkItems={false}
            actionText={actionTaken}
            onViewDetails={() => {}}
          />
        </div>
      </Paper>
    </div>
  );
}
